import React from 'react';

const HomePage = () => {
  return (
    <div>homePage</div>
  );
}

export default HomePage;